import React, { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const webPortfolioData = [
    {
        screenshots: [
            "/portfolio/web dev screenshots/Screenshot 2026-01-22 at 11.49.16 AM.webp",
            "/portfolio/web dev screenshots/Screenshot 2026-02-05 at 12.09.57 PM.webp",
            "/portfolio/web dev screenshots/Screenshot 2026-02-05 at 12.10.05 PM.webp",
            "/portfolio/web dev screenshots/Screenshot 2026-02-05 at 12.10.12 PM.webp",
            "/portfolio/web dev screenshots/Screenshot 2026-02-05 at 12.10.47 PM.webp",
            "/portfolio/web dev screenshots/nft-shot2.webp",
            "/portfolio/web dev screenshots/styles-conference.webp"
        ],
        title: "Web Development Projects",
        description: "A collection of web applications and interfaces demonstrating responsive design and modern UI/UX."
    }
]

const WebPortfolio = () => {
    const [letterClass, setLetterClass] = useState('text-animate');

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    const renderPortfolio = (portfolio) => {
        return (
            <div className="images-container">
                {
                    portfolio.map((port, idx) => {
                        return <PortfolioItem key={idx} port={port} />;
                    })
                }
            </div>
        );
    }

    return (
        <>
            <div className="container portfolio-page web-portfolio-page">
                <h1 className="page-title">
                    <AnimatedLetters
                        letterClass={letterClass}
                        strArray={"Web Development".split("")}
                        idx={15}
                    />
                </h1>
                <div>{renderPortfolio(webPortfolioData)}</div>
            </div>
            <Loader type="ball-scale-multiple" />
        </>
    );
}

const PortfolioItem = ({ port }) => {
    const [currentIdx, setCurrentIdx] = useState(0);

    const nextImage = () => {
        setCurrentIdx((prev) => (prev + 1) % port.screenshots.length);
    };

    const prevImage = () => {
        setCurrentIdx((prev) => (prev - 1 + port.screenshots.length) % port.screenshots.length);
    };

    return (
        <div className="image-box">
            <div className="carousel-content">
                <button className="nav-btn prev" onClick={prevImage}>&#10094;</button>
                <img
                    src={port.screenshots[currentIdx]}
                    className="portfolio-image"
                    alt="portfolio" />
                <button className="nav-btn next" onClick={nextImage}>&#10095;</button>
            </div>
            <div className="content">
                <p className="title">{port.title}</p>
                <h4 className="description">{port.description}</h4>
            </div>
        </div>
    )
}

export default WebPortfolio
